const Rakamlar = resolve => {
    require.ensure(['../views/apps/rakamlar/Rakamlar'], () => {
        resolve(require('../views/apps/rakamlar/Rakamlar'))
    })
};

const RakamlarIslem = resolve => {
    require.ensure(['../views/apps/rakamlar/RakamlarIslem'], () => {
        resolve(require('../views/apps/rakamlar/RakamlarIslem'))
    })
};

import Vue from 'vue'
Vue.component('Rakamlar', RakamlarIslem);

import layouts from '../layout'

export default {
    path: '/rakamlar',
    name: 'rakamlar',
    component: Rakamlar,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'islem',
            name: 'rakamlarislem',
            component: RakamlarIslem,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ]
}
